import React, { useState, useEffect } from 'react';
import "../components/styles/CustomProductSecondPage.css";
import {useNavigate} from "react-router-dom";
import { z } from "zod";
import {useLoggedInUserId} from "../api/GetLoggedInUserId";

const CustomProductSecondPage = () => {
    let navigate = useNavigate();
    const [files, setFiles] = useState([]);
    const [formData, setFormData] = useState({
        name: '', email: '', phoneNumber: '', title: '', content: '', fileNames: ''
    });
    const [tempArticleId, setTempArticleId] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [errors, setErrors] = useState({});
    const [isAuthenticated, setIsAuthenticated] = useState(false);  // 로그인 여부 확인

    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    const MAX_FILE_COUNT = 5;

    // ✅ 로그인된 사용자 ID 가져오기
    const { data: memberId, isLoading, isError } = useLoggedInUserId();

    // ✅ 유효성 검사 스키마 (Zod)
    const schema = z.object({
        name: z.string().min(2, "이름은 2~10자 이내여야 합니다.").max(10, "이름은 2~10자 이내여야 합니다."),
        email: z.string().email("올바른 이메일 형식이어야 합니다."),
        phoneNumber: z.string().regex(/^010\d{8}$/, "전화번호는 010으로 시작하는 11자리 숫자여야 합니다."),
        title: z.string().min(5, "제목은 5~100자 이내여야 합니다.").max(100, "제목은 5~100자 이내여야 합니다."),
        content: z.string().min(10, "내용은 10~1000자 이내여야 합니다.").max(1000, "내용은 10~1000자 이내여야 합니다."),
    });

    // ✅ 기존 임시저장된 데이터 불러오기
    useEffect(() => {
        const fetchDraft = async () => {
            try {
                // 로그인 되어있다면 임시저장 버튼 활성화
                if (memberId) {
                    setIsAuthenticated(true);
                }

                const response = await fetch('/api/apply/custom-product');
                if (response.ok) {
                    const data = await response.json();
                    setFormData({
                        name: data.name || '',
                        email: data.email || '',
                        phoneNumber: data.phoneNumber || '',
                        title: data.title || '',
                        content: data.content || '',
                    });
                    setTempArticleId(data.applicationArticleId);
                    setFiles(data.fileNames.split(","));
                }
            } catch (error) {
                console.error("임시저장 데이터 불러오기 실패:", error);
            }
        };
        fetchDraft();
    }, []);

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //
    //     setFormData((prev) => ({ ...prev, [name]: value }));
    // };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        let totalFiles = files.length + selectedFiles.length;

        if (totalFiles > MAX_FILE_COUNT) {
            alert("파일은 최대 5개까지만 업로드할 수 있습니다.");
            return;
        }

        const validFiles = selectedFiles.filter((file) => {
            if (file.size > MAX_FILE_SIZE) {
                alert(`${file.name}은(는) 10MB를 초과하였습니다.`);
                return false;
            }
            return true;
        });

        setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    };

    // ✅ 맞춤상품 신청 제출 기능
    const handleSubmit = async (e) => {
        e.preventDefault();

        // const data = new FormData();
        // data.append('name', formData.name);
        // data.append('email', formData.email);
        // data.append('phoneNumber', formData.phoneNumber);
        // data.append('title', formData.title);
        // data.append('content', formData.content);

        // files.forEach((file) => {
        //     data.append('files', file);
        // });

        schema.parse(formData);
        setErrors({});

        // json화
        const data = {
            name: formData.name,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            title: formData.title,
            content: formData.content,
            fileNames: files.join(",")
        }

        try {
            const response = await fetch('/api/apply/custom-product', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                alert('신청이 성공적으로 제출되었습니다!');
                navigate("/custom-product-first");
            } else {
                alert('신청 제출 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('신청 제출 중 오류:', error);
            alert('서버 오류');
        }
    };

    const handleSaveDraft = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.phoneNumber || !formData.title || !formData.content) {
            alert("필수 항목을 모두 입력해주세요.");
            return;
        }

        schema.parse(formData);
        setErrors({});

        // ✅ JSON 데이터로 변환
        const requestData = {
            name: formData.name,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            title: formData.title,
            content: formData.content,
            fileNames: files.join(","), // ✅ JSON 요청에는 파일명을 문자열 리스트로 전달
        };

        console.log(requestData);

        try {
            const response = await fetch("/api/apply-form/temporary-store", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();

            if (result.message === "임시저장이 완료되었습니다.") {
                alert("임시저장 완료!");
            } else if (result.message === "로그인이 필요합니다.") {
                alert("로그인 후 이용해주세요.");
            } else {
                alert("임시저장 실패");
            }
        } catch (error) {
            console.error("임시저장 중 오류 발생:", error);
            alert("서버 오류");
        }
    };


    // ✅ 임시저장 삭제
    const handleDeleteDraft = async () => {
        if (!tempArticleId) {
            alert("삭제할 임시저장 내역이 없습니다.");
            return;
        }

        try {
            const response = await fetch(`/api/application/temp/${tempArticleId}`, {
                method: 'DELETE',
            });

            const result = await response.json();

            if (result.result === 'success') {
                alert("임시저장 삭제 완료!");
                setFormData({ name: '', email: '', phoneNumber: '', title: '', content: '' });
                setTempArticleId(null);
            } else {
                alert("임시저장 삭제 실패");
            }
        } catch (error) {
            console.error("임시저장 삭제 중 오류:", error);
            alert("서버 오류");
        }
    };

    const handleFileUpload = async (event) => {
        const files = event.target.files; // ✅ 파일 가져오기
        if (!files.length) {
            alert("파일을 선택해주세요.");
            return;
        }

        const data = new FormData();
        for (const file of files) {
            data.append("file", file);
        }

        try {
            const response = await fetch("/api/upload-file", {
                method: "POST",
                body: data,
            });

            const result = await response.json();

            if (result.result === "success") {
                setUploadedFiles((prev) => [...prev, result.d]); // storeFileName 저장
                setFiles((prev) => [...prev, result.filename]);
                alert("파일 업로드 성공!");
            } else {
                alert("파일 업로드 실패");
            }
        } catch (error) {
            console.error("파일 업로드 오류:", error);
            alert("서버 오류");
        }
    };


    const handleFileDelete = async (index) => {
        // 해당 파일 이름 가져오기
        let fileName = uploadedFiles[index];

        if (!fileName) {
            alert("임시 저장된 파일은 삭제가 불가능합니다.");
            return;
        }

        try {
            const response = await fetch(`/api/delete-file?fileId=${fileName}`, {
                method: "GET",
            });

            const result = await response.json();

            if (result.result === "success") {
                setUploadedFiles((prev) => prev.filter((f) => f !== fileName));
                setFiles((prev) => prev.filter((f, i) => i !== index));

                // input value 초기화

                alert("파일 삭제 성공!");
            } else {
                alert("파일 삭제 실패");
            }
        } catch (error) {
            console.error("파일 삭제 오류:", error);
            alert("서버 오류");
        }
    };

    // ✅ 입력 변경 핸들러
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        validateField(name, value);
    };

    // ✅ 실시간 입력 검증
    const validateField = (name, value) => {
        try {
            schema.pick({ [name]: schema.shape[name] }).parse({ [name]: value });
            setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        } catch (error) {
            if (error instanceof z.ZodError) {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: error.errors[0].message }));
            }
        }
    };

    // ✅ 예시 파일 다운로드
    const handleExampleDownload = async () => {
        try {
            const res = await fetch("/api/download-example-file");
            if (!res.ok) {
                alert("❌ 예시 파일 다운로드 실패");
                return;
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "소프트웨어_요구사항_명세서_SRS.docx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            alert("✅ 예시 파일 다운로드 완료!");
        } catch (error) {
            console.error("다운로드 중 오류 발생:", error);
            alert("서버 오류로 다운로드에 실패했습니다.");
        }
    };



    return (
        <div className="custom-form-page">
            <div className="form-container">
                <h1 className="form-title">맞춤상품 상담신청</h1>
                <form className="custom-form" onSubmit={handleSubmit}>
                    {[
                        { label: "이름", name: "name", type: "text" },
                        { label: "이메일", name: "email", type: "email" },
                        { label: "전화번호", name: "phoneNumber", type: "text" },
                        { label: "제목", name: "title", type: "text" },
                    ].map(({ label, name, type }, index) => (
                        <div key={index} className="form-group">
                            <label className="form-label">
                                {label}
                                <span className="required">*</span>
                            </label>
                            <input
                                type={type}
                                name={name}
                                placeholder={`${label}을 입력해 주세요`}
                                className="form-input"
                                value={formData[name]}
                                onChange={handleInputChange}
                                required
                            />
                            {errors[name] && <p className="error-message">{errors[name]}</p>}
                        </div>
                    ))}

                    <div className="form-group">
                        <label className="form-label">파일<span className="required">*</span></label>
                        <input type="file" className="form-input" onChange={(e) => handleFileUpload(e)} />
                        <ul className="file-list">
                            {files.map((file, index) => (
                                <li key={index} className="file-item">
                                    {file}
                                    <button type="button" className="delete-button" onClick={() => handleFileDelete(index)}>삭제</button>
                                </li>
                            ))}
                        </ul>
                        <small className="file-info">* 파일당 최대 10MB, 최대 5개까지 업로드 가능합니다.</small>
                    </div>

                    <div className="form-group">
                        <label className="form-label">설명<span className="required">*</span></label>
                        <textarea
                            name="content"
                            placeholder="문의하실 내용을 자유롭게 써주세요(10자이상)"
                            className="form-textarea"
                            value={formData.content}
                            onChange={handleInputChange}
                            required
                        ></textarea>
                        <span className="char-count">{formData.content.length}/1000</span>
                        {errors.content && <p className="error-message">{errors.content}</p>}
                    </div>

                    <div className="form-example">
                        <p className="form-example-text">예시 파일 첨부</p>
                        <p className="form-example-text">- 예시파일은 상담신청을 위한 참고자료입니다. 아래의 자료를 다운로드 받아 확인해주세요.</p>
                        <a className="form-example-link" onClick={handleExampleDownload} download>소프트웨어_요구사항_명세서_SRS</a>
                    </div>

                    <div className="form-warnings">
                        <p className="form-warning">맞춤상품
                            상담 신청시 유의사항</p>
                        <p className="form-warning">- 상담 신청이 완료되면 영업일 1~2일내로 연락을 드리오니, 수신에 유의하여
                            주시기 바랍니다.</p>
                        <p className="form-warning">- 본 상담 신청서는 보다 원활한 상담을 위해 작성하는 초기 단계로, 작성
                            예시를 참고하여 간단하게 작성해주세요. 더 세부적인 사항에 관한 내용은 추후 상담을 통해 전달해주시기 바랍니다.</p>
                        <p className="form-warning">- 임시저장 또는 제출된 상담 신청 내역은 "마이페이지>상담신청내역"에서 볼
                            수 있습니다.</p>
                        <p className="form-warning">- 로그인하지않은 상태로 신청된 상담내역의 다시보기 서비스는 존재하지
                            않습니다. 수정 및 재확인이 필요한 경우 고객센터를 이용해주세요.</p>
                        <p className="form-warning">- 법에 저촉되는 프로그램 문의는 일체 받지 않습니다.</p>
                        <p className="form-warning">- 맞춤상품 신청 후에는 조회만 가능하며, 수정이 불가능합니다.</p>
                    </div>
                    <div className="form-buttons">
                        <button type="submit" className="submit-button">신청하기</button>
                        {isAuthenticated && (
                            <button type="button" className="save-button" onClick={handleSaveDraft}>임시저장</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CustomProductSecondPage;
